<template>
    <!-- 目标用户 -->
    <div class="target_user">
        <div class="containers">
            <div class="HeaderTitle" ref="HeaderTitle">
                <h1 class="partH1">目标用户</h1>
                <p class="target_user_info">&nbsp致力于解决企业级车务管理</p>
            </div>
            <ul ref="ul">
                <li v-for="(item,i) in targetuser" :key="i" :ref="'li'+i" class="targetuser_bg" :style="{background: 'url('+item.bg+')' }">
                    <div class="targetuser_title"><span>{{item.title}}</span></div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import animationUtils from "@/utils/animationUtils.js";
    import animationIndex from "@/utils/animationIndex.js";

    export default {
        props: {
            targetuser: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                liDom: [],
            }
        },
        mounted() {
            this.targetuser.forEach((item, index) => { //获取需要给加动画的各个li的ref节点
                this.liDom.push(this.$refs[`li${index}`][0].classList);
            })

            window.addEventListener("scroll", this.menu);
        },
        beforeDestroy() { //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
            window.removeEventListener("scroll", this.menu)
        },
        methods: {
            menu() {
                let ulOffsetTop = this.$refs.ul.offsetTop; //获取当前元素距离文档顶部的高度
                /**
                 * animationIndex第一个参数为需要动画的dom元素的高度，
                 * 第二个参数为li的每个单元的dom样式类数组
                 * 第三个参数为动画样式类名称
                 * 第四个参数为每个li动画执行间隔时间
                 * */
                animationIndex.animationIndex(ulOffsetTop, this.liDom, "fade--in", 600);

                /**
                 * animations方法的第一个参数是需要动画的dom元素的高度，
                 * 第二个参数是需要加动画的dom元素的样式列表数组，
                 * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
                 */
                //第二部分标题动画
                let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
                let HeaderTitle = this.$refs.HeaderTitle.classList;
                animationUtils.animations(HeaderTitleOffsetTop, HeaderTitle, "activeTitle");
            }
        },
    };
</script>

<style scoped>
    .target_user .partH1 {
        opacity: 1;
    }
    .HeaderTitle{
        opacity: 0;
    }
</style>